import FlatList from './FlatList';
export type { InfiniteSwiperProps } from './FlatList';

export default {
  FlatList,
};
